import { render, staticRenderFns } from "./audio-recording-response.vue?vue&type=template&id=9d23ae6a&scoped=true&"
import script from "./audio-recording-response.vue?vue&type=script&lang=js&"
export * from "./audio-recording-response.vue?vue&type=script&lang=js&"
import style0 from "./audio-recording-response.vue?vue&type=style&index=0&id=9d23ae6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d23ae6a",
  null
  
)

component.options.__file = "audio-recording-response.vue"
export default component.exports